export const AI_REVIEW_SOURCE = 'ai';
export const AI_REVIEW_TEXT_COLOR = '#7c2d12';
export const AI_REVIEW_ACCEPTED_COLOR = '#1e88e5';

